<template>
    <dash
        icon="fa fa-book"
        titulo="DESPESAS"
        subTitulo="REQUISITANTE"
        @click.native="$router.push({ name: 'DespesasGerais_Requisitantes_Despesas' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>